
import { defineComponent, PropType } from 'vue'
import { iBusinessModel } from '../../../Metaweb'
import Accordion from 'primevue/accordion'
import AccordionTab from 'primevue/accordiontab'
import Dropdown from 'primevue/dropdown'
import metawebBusinessPropertyListTabDescriptor from './MetawebBusinessPropertyListTabDescriptor.json'
import MultiSelect from 'primevue/multiselect'

export default defineComponent({
    name: 'metaweb-business-property-list-tab',
    components: { Accordion, AccordionTab, Dropdown, MultiSelect },
    props: { selectedBusinessModel: { type: Object as PropType<iBusinessModel | null> }, roles: { type: Array }, propMeta: { type: Object } },
    emits: ['metaUpdated'],
    data() {
        return {
            metawebBusinessPropertyListTabDescriptor,
            meta: null as any,
            businessModel: null as iBusinessModel | null,
            categories: [] as any[],
            roleOptions: [] as any[]
        }
    },
    computed: {
        profileAttributes(): any[] {
            return (this.$store.state as any).user.attributes ? Object.keys((this.$store.state as any).user.attributes) : []
        }
    },
    watch: {
        selectedBusinessModel() {
            this.loadMeta()
            this.loadBusinessModel()
        },
        roles() {
            this.loadRoleOptions()
        }
    },
    created() {
        this.loadMeta()
        this.loadBusinessModel()
    },
    methods: {
        loadMeta() {
            this.meta = this.propMeta as any
        },
        loadBusinessModel() {
            this.businessModel = this.selectedBusinessModel as iBusinessModel

            this.loadCategories()
        },
        loadRoleOptions() {
            this.roleOptions = this.roles as any[]
        },
        loadCategories() {
            this.categories = {} as any
            if (this.businessModel) {
                for (let i = 0; i < this.businessModel.properties.length; i++) {
                    const tempProperty = this.businessModel?.properties[i]

                    const key = Object.keys(tempProperty)[0]
                    const newKey = key?.split('.')

                    if (!this.categories[newKey[0]]) {
                        this.categories[newKey[0]] = []
                    }

                    this.categories[newKey[0]].push({ ...tempProperty[key], type: key })
                }
            }
        },
        updateCategoryValue(property: any) {
            this.businessModel?.properties?.forEach((el: any) => {
                const key = Object.keys(el)[0]
                if (key === property.type) {
                    el[key].value = property.value
                }
            })

            this.$emit('metaUpdated')
        }
    }
})
